
define('app/dashboard/account/accountMain',[
	'domReady',
	'app/dashboard/account/accountApp',
	'app/common/setup'
], function(domReady, AccountApp, Setup){
	domReady(function () {
		Setup.initialize();
		AccountApp.initialize();
    });
});